import React from 'react';
import { Link } from 'react-router-dom';
import { getFotoUrl } from '../services/api';
import './AnuncioCard.css';

const AnuncioCard = ({ anuncio, podeVerDetalhes, isLogado, usuario, onClick }) => {
    const formatPrice = (value) => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 0
        }).format(value);
    };

    const handleCardClick = (e) => {
        if (onClick) {
            onClick(e, anuncio.id);
        }
    };

    const rawMediaUrl = anuncio.imagem;
    const isVideo = rawMediaUrl && (
        rawMediaUrl.match(/\.(mp4|mov|avi|webm)$/i) || 
        rawMediaUrl.includes('/video/upload/') ||
        (anuncio.midias?.length > 0 && anuncio.midias[0].tipo === 'video')
    );

    return (
        <Link
            to={`/anuncio/${anuncio.id}`}
            className="anuncio-card-new"
            onClick={handleCardClick}
        >
            <div className="anuncio-card-image-container">
                <img 
                    src={anuncio.imagem ? getFotoUrl(anuncio.imagem) : 'https://via.placeholder.com/400x300?text=Sem+Foto'} 
                    alt={anuncio.titulo} 
                    className="anuncio-card-img" 
                />
                {isVideo && (
                    <div className="video-badge-overlay">
                        <span>▶</span>
                    </div>
                )}
                <div className="anuncio-card-badge-top">
                    {anuncio.categoria}
                </div>
            </div>

            <div className="anuncio-card-body">
                <h3 className="anuncio-card-title">{anuncio.titulo}</h3>
                
                <div className="anuncio-card-meta">
                    <div className="anuncio-card-meta-item">
                        <span className="meta-icon">📍</span>
                        <span className="meta-text">{anuncio.cidade} - {anuncio.estado}</span>
                    </div>
                    
                    {anuncio.categoria?.toLowerCase() !== 'outros' && (
                        podeVerDetalhes ? (
                            <div className="anuncio-card-specs-row">
                                <div className="anuncio-card-meta-item">
                                    <span className="meta-icon">⚖️</span>
                                    <span className="meta-text">
                                        {(anuncio.pesoMedio || anuncio.peso) ? `${anuncio.pesoMedio || anuncio.peso} ${anuncio.unidadePeso || 'kg'}` : 'N/A'}
                                    </span>
                                </div>
                                <div className="anuncio-card-meta-item">
                                    <span className="meta-icon">📅</span>
                                    <span className="meta-text">
                                        {(anuncio.idadeMeses || anuncio.idade) ? `${anuncio.idadeMeses || anuncio.idade} ${anuncio.unidadeIdade || 'meses'}` : 'N/A'}
                                    </span>
                                </div>
                            </div>
                        ) : (
                            <div className="anuncio-card-locked-badge">
                                <span className="meta-icon">🔒</span>
                                <span className="meta-text">Login p/ ver mais</span>
                            </div>
                        )
                    )}
                </div>

                <div className="anuncio-card-footer">
                    {podeVerDetalhes ? (
                        <div className="anuncio-card-price">
                            <span className="price-label">Preço</span>
                            <span className="price-value">{formatPrice(anuncio.preco)}</span>
                        </div>
                    ) : (
                        <div className="anuncio-card-price-locked">
                            <span>Fazer login p/ ver preço</span>
                        </div>
                    )}
                    <div className="anuncio-card-action">
                        Ver detalhes
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default AnuncioCard;
